import firebase from '../firebase/firebase';
import { types } from './types';
import { notifyUser } from './notification-actions';

const db = firebase.database();

export const confirmBookingData = (values) => async dispatch => {
    return new Promise(function(resolve, reject) {
        if (values){
            dispatch({
                type: types.CONFIRM_BOOKING_DATA_SUCCESS,
                payload: values
            });
            resolve();
        } else {
            dispatch({
                type: types.CONFIRM_BOOKING_DATA_FAIL,
            });
            reject();
        }
    });
}

export const resetBookingData = () => {
    return {
        type: types.RESET_BOOKING_DATA,
        payload: null
    }
    // THIS IS HANDLED BY CALENDAR ACTIONS
}

export const sendHelpFormData = (values, userData) => async dispatch => {
    db.ref(`formFeedback/${userData.uid}`)
    .set(values)
    .then(() => {
        // console.log('STUFF SENT');
        dispatch(notifyUser({
            visible: true,
            message: 'Your message has been sent!',
            textColor: 'white'
        }))
        
    })
    .catch(e => {
        // console.log('ERROR', e);
        dispatch(notifyUser({
            visible: true,
            message: 'Sorry, looks like there was a problem sending your message.',
            textColor: 'white'
        }))
    });
}

export const setFormType = (formType) => dispatch => {
    dispatch({
        type: types.SET_FORM_TYPE,
        payload: formType
    });
}

export const saveEndConsultSessionReason = ({ formData, formDataType, sessionData:booking, user }) => async dispatch => {
    return new Promise((resolve, reject) => {
        let action = {
            type: null,
            payload: formData
        };
        let updates = {};
        console.log('BOOKING', booking);
        switch (formDataType) {
            case "reasonOnly":
                // TODO
                booking.endConsultReason = formData;
                updates[`endConsultReason/${booking.key}/${user.uid}`] = formData;
                action.type = types.GET_END_CONSULT_SESSION_REASON;
                break;
            case "otherDetails":
                // TODO
                updates[`endConsultReason/${booking.key}/${user.uid}`] = formData;
                // action.type = types.GET_END_CONSULT_SESSION_REASON;
                break;
            case "technicalDetails":
                // TODO send email
                // TODO send reason to 
                const message = {
                    details: formData,
                    feedbackSupportType: {
                        label: 'Video Consult Bug Report'
                    }
                }
                dispatch(sendHelpFormData(message, user));
                updates[`endConsultReason/${booking.key}/${user.uid}`] = 'Technical problem occurred';
                // action.type = types.GET_END_CONSULT_SESSION_REASON;
                break;
            default:
    
        }
        db.ref().update(updates, (error) => {
            if (error) {
                console.log('FIREBASE ERROR:', error);
            } else {
                dispatch(action);
                resolve();
            }
        })
        
        console.log('SESSION DATA @ EndReason', booking)

    })
}

export const markConsultSessionAsComplete = (booking, user) => async dispatch => {
    return new Promise((resolve, reject) => {
        let action = {
            type: types.MARK_CONSULT_AS_COMPLETE,
            payload: null
        };
        
        db.ref(`markConsultComplete/${booking.key}/${user.uid}`).set(true, (error) => {
            if (error) {
                console.log('FIREBASE ERROR:', error);
            } else {
                dispatch(action);
                resolve();
            }
        })
    })
}


// WEBPACK FOOTER //
// ./src/js/actions/form-actions.js